module.exports = __webpack_public_path__ + "static/media/icon_frame_adding.fb190ff5.png";